import { GlobalWebsiteService } from './apps/global-site/global-website.service';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { LayoutService } from './layout/layout.service';
import { DOCUMENT } from '@angular/common';
import * as g from 'src/app/globals';
import { AuthenticationService } from './authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Website } from './apps/website/interfaces/PagesCategories';
import { IndexDbService } from './apps/storage/indexedDB/index-db.service';
import { Stores } from './apps/storage/indexedDB/stores.enum';
import { UserIdentity } from './models/UserIdentity';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent implements AfterViewInit, OnInit {
  areaId: number;
  screenSizeValue: string;
  applicationError: boolean;
  applicationErrorDetails: {};
  isLoggedIn = false;
  website: Website;
  set screenSize(value: string) {
    this.document.body.classList.remove(this.screenSizeValue);
    this.document.body.classList.add(value);

    this.screenSizeValue = value;
  }

  get screenSize() {
    return this.screenSizeValue;
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    breakpointObserver: BreakpointObserver,
    private layoutService: LayoutService,
    private authenticateService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private globalService: GlobalWebsiteService,
    private dbService: IndexDbService,
    private authenticationService: AuthenticationService
  ) {
    breakpointObserver.observe([Breakpoints.XLarge]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'x-large';
        this.layoutService.changeScreenSize(this.screenSize);
      }
    });

    breakpointObserver.observe([Breakpoints.Large]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'large';
        this.layoutService.changeScreenSize(this.screenSize);
      }
    });

    breakpointObserver.observe([Breakpoints.Medium]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'medium';
        this.layoutService.changeScreenSize(this.screenSize);
      }
    });

    breakpointObserver.observe([Breakpoints.Small]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'small';
        this.layoutService.changeScreenSize(this.screenSize);
      }
    });

    breakpointObserver.observe([Breakpoints.XSmall]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'x-small';
        this.layoutService.changeScreenSize(this.screenSize);
      }
    });
  }

  ngOnInit() {
    this.isLoggedIn = g.getToken() !== '' && g.getToken() != null;
    if (!this.isLoggedIn && g.navigateToWebsites) {
      this.getWebsite();
    }
    if (this.isLoggedIn) {
      this.authenticationService
        .getIdentityDetails()
        .subscribe((identity: any) => {
          this.areaId = identity.Area;
          this.getThemeSettings(this.areaId);
        });
    }
  }

  ngAfterViewInit() {
    this.authenticateService.initializeScripts.subscribe(() => {
      console.log('ngAfterViewInit>> initializeScripts');
      this.initScripts();
    });
    this.applicationError = g.applicationError;
    this.applicationErrorDetails = g.applicationErrorDetails;

    if (g.applicationError) {
      return;
    }

    const favIcon = document.querySelector('#appIcon') as HTMLLinkElement;
    favIcon.href = g.baseUrl + 'Account/Favicon';
    console.log('ngAfterViewInit << initializeScripts');
    this.getConfig().then(() => {});
    this.initScripts();
  }

  initScripts() {
    if (g.getToken() === '') {
      this.layoutService
        .getScriptsUnauthorized()
        .subscribe((scripts: number[]) => {
          scripts.forEach((script) => {
            const scriptEle = this.document.createElement('script');
            scriptEle.className = 'data-bweb-script';
            scriptEle.type = 'text/javascript';
            scriptEle.src = `${
              g.apiBaseUrl
            }Miscellaneous/ScriptJs?id=${script}&${g.getUrlSuffix()}`;

            this.document
              .getElementsByTagName('body')
              .item(0)
              .appendChild(scriptEle);
          });
        });
      this.layoutService
        .getStylesUnauthorized()
        .subscribe((scripts: number[]) => {
          scripts.forEach((script) => {
            const styleEle = this.document.createElement('link');
            styleEle.className = 'data-bweb-script';
            styleEle.rel = 'stylesheet';
            styleEle.href = `${g.apiBaseUrl}Miscellaneous/StyleJs?id=${script}`;

            this.document
              .getElementsByTagName('head')
              .item(0)
              .appendChild(styleEle);
          });
        });

      return;
    }

    if (window.location !== window.parent.location) {
      return;
    }

    if (g.getToken() == undefined || g.getToken() == null) {
      this.LoadScriptUnauthroized();
      return;
    }

    this.authenticateService
      .isTokenValidAsync()
      .subscribe((tokenStatus: { Success: boolean; Message: string }) => {
        if (tokenStatus.Success) {
          this.layoutService.getScripts().subscribe((scripts: number[]) => {
            scripts.forEach((script) => {
              const scriptEle = this.document.createElement('script');
              scriptEle.className = 'data-bweb-script';
              scriptEle.type = 'text/javascript';
              scriptEle.src = `${
                g.apiBaseUrl
              }Layout/ScriptJs?id=${script}&${g.getUrlSuffix()}`;

              this.document
                .getElementsByTagName('body')
                .item(0)
                .appendChild(scriptEle);
            });
          });
          this.layoutService.getStyles().subscribe((scripts: number[]) => {
            scripts.forEach((script) => {
              const styleEle = this.document.createElement('link');
              styleEle.className = 'data-bweb-script';
              styleEle.rel = 'stylesheet';
              styleEle.href = `${g.apiBaseUrl}Miscellaneous/StyleJs?id=${script}`;
              //}Layout/StyleJs?id=${script}`;

              this.document
                .getElementsByTagName('head')
                .item(0)
                .appendChild(styleEle);
            });
          });
        } else {
          this.LoadScriptUnauthroized();
          return;
        }
      });
  }

  private LoadScriptUnauthroized() {
    this.layoutService
      .getScriptsUnauthorized()
      .subscribe((scripts: number[]) => {
        scripts.forEach((script) => {
          const scriptEle = this.document.createElement('script');
          scriptEle.className = 'data-bweb-script';
          scriptEle.type = 'text/javascript';
          scriptEle.src = `${
            g.apiBaseUrl
          }Miscellaneous/ScriptJs?id=${script}&${g.getUrlSuffix()}`;

          this.document
            .getElementsByTagName('body')
            .item(0)
            .appendChild(scriptEle);
        });
      });
    this.layoutService
      .getStylesUnauthorized()
      .subscribe((scripts: number[]) => {
        scripts.forEach((script) => {
          const styleEle = this.document.createElement('link');
          styleEle.className = 'data-bweb-script';
          styleEle.rel = 'stylesheet';
          styleEle.href = `${g.apiBaseUrl}Miscellaneous/StyleJs?id=${script}`;

          this.document
            .getElementsByTagName('head')
            .item(0)
            .appendChild(styleEle);
        });
      });
  }

  getWebsite() {
    this.globalService.getDefaultWebsite().subscribe((res: any) => {
      const url = this.router.url;
      const testUrl = window.location.href;
      console.log(url, testUrl);
      // ;
      if (
        url.indexOf('resetpassword') > -1 ||
        testUrl.indexOf('resetpassword') > -1
      ) {
        return;
      }

      if (res != null && res !== false && g.navigateToWebsites) {
        this.router.navigate(['/global/home']);
        this.website = res;
        this.globalService.assignWebsite(this.website);
      } else {
        if (g.redirectToEmployeeLogin) {
          this.router.navigate(['/apps/authentication/login']);
        } else if (g.redirectToExternalLogin) {
          this.router.navigate(['/apps/authentication/external-login']);
        } else {
          this.router.navigate(['/apps/authentication/landing']);
        }
      }
      // this.getDefaultPage(this.website.DefaultPage);
      // this.getPages(this.website.Id);
      // this.getBlocks([+this.website.FooterBlock, +this.website.HeaderBlock]);
    });
  }
  refresh(): void {
    window.location.reload();
  }
  getConfig(): Promise<void> {
    return fetch('/config.json')
      .then((response) => {
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then((config) => {
        if (config) {
          g.setUiSettings(config);
        }
        g.setNotifications({
          disableAlertBell: config.DisableAlertBell,
          alertRefreshFrequency: config.AlertRefreshFrequency,
          disableCountEndpoint: config.DisableCountEndpoint,
        });
        g.setShowDownloadButton({
          ShowDownloadButton: config.ShowDownloadButton,
        });
        if (config.styleQueryId) {
          g.setQueryId('styleQueryId', config.styleQueryId);
        }
        if (config.DownloadFilesQueryId) {
          g.setQueryId('DownloadFilesQueryId', config.DownloadFilesQueryId);
        }
      })
      .catch((err) => {
        console.error('Failed to load config.json', err);
      });
  }

  getThemeSettings(areaId: number) {
    if (areaId !== 2 && areaId !== 3) return;
    const queryId = g.getQueryId('styleQueryId');
    if (!queryId) return;
    this.layoutService.executeQuery(queryId).subscribe({
      next: (data: any[]) => {
        if (data && data.length > 0) {
          const item = data[0];

          if (item.BackgroundColor) {
            const rgb = this.hexToRgb(item.BackgroundColor);
            if (rgb) {
              g.setPrimaryColor(`${rgb.r}, ${rgb.g}, ${rgb.b}`);
            }
          }

          if (item.Logo) {
            g.setLogoUrl(item.Logo);
          }
        }
      },
    });
  }
  hexToRgb(hex: string) {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((c) => c + c)
        .join('');
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return { r, g, b };
  }
}
